import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemPermissionsRoute: InvariantJiraRoute = {
	name: 'global-settings-system-permissions',
	path: '/secure/admin/GlobalPermissions([!%]?[\\w]*).jspa',
};
